<div class="modal fade0" id="cmodal" tabindex="-1" role="dialog" aria-labelledby="cmodalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document" style="width:97%; max-width:initial">
    <div class="modal-content" style="padding:20px">
      
      <div class="card card-primary">
        <div class="card-header" *ngIf="service.model">
          {{service.model.model.tit}}
        </div>
        <div class="card-body" style="background-color: #f9f9fb;">
      
          <div *ngIf="service.model">
            <app-chtm *ngIf="service.model.model.ctyp=='chtm'" [model]="service.model.model" [dyn]="service.dyn"></app-chtm>
            <app-grid *ngIf="service.model.model.ctyp=='grid' && service.model.model.dis==5" [model]="service.model.model" [dyn]="service.dyn"></app-grid>
            <app-formy *ngIf="service.model.model.ctyp=='grid' && service.model.model.disf==5" [model]="service.model.model" [dyn]="service.dyn"></app-formy>
            <app-chart *ngIf="service.model.model.ctyp=='chart'" [model]="service.model.model" [dyn]="service.dyn"></app-chart>
            <app-treev *ngIf="service.model.model.ctyp=='treev'" [model]="service.model.model" [dyn]="service.dyn"></app-treev>
          </div>
        </div>
        <div class="card-footer" *ngIf="false">
          <button type="button" *ngIf="service.model && service.model.model.ctyp=='grid'" class="btn btn-secondary" (click)="service.unimplement()"> &nbsp; انصراف &nbsp; </button>
          &nbsp;
          <button type="button" *ngIf="service.model && service.model.model.ctyp=='grid'" class="btn btn-success" (click)="service.apply()"> &nbsp; تایید &nbsp; </button>
        </div>
      </div>
    </div>
  </div>
</div>